import { gql } from "@apollo/client"

const GET_SESSION_TIMEOUT_CONFIG = gql`
{
	GetGlobalConfig(
    configType:"sessionTimeout" 
    configKeys:["userInactivityResponseSeconds", "userInactivityLimitMinutes", "userConfigRefreshIntervalHours"]) 
  {
	  key
	  value
	}
}
`

export { GET_SESSION_TIMEOUT_CONFIG }